/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spinner, Text } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";

function Loading() {
  return (
    <FlexContainer>
      <Spinner size="sm" />
      <Text weight="regular" tag="div" css={{ marginLeft: "1rem" }}>
        Loading ...
      </Text>
    </FlexContainer>
  );
}
export { Loading };
